var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0177 3.66072C18.5783 3.22142 18.0019 3.00166 17.4289 3.00166C16.8532 3.00166 16.2774 3.22135 15.8381 3.66072L4.58557 14.9139C4.2844 15.215 4.07484 15.5955 3.98169 16.0109L3.01121 20.3273C2.9402 20.6504 3.21645 20.9983 3.5606 20.9983C3.5974 20.9983 3.63498 20.9947 3.67301 20.9871C3.67301 20.9871 6.64703 20.3562 7.9894 20.0405C8.39503 19.945 8.75812 19.7409 9.05268 19.4465L20.3428 8.15637C21.2212 7.27798 21.218 5.85687 20.3396 4.97848L19.0177 3.66072ZM7.85766 18.2531C7.78332 18.3275 7.69938 18.3749 7.60078 18.3981C6.96211 18.5485 5.93257 18.7745 5.04575 18.9668L5.62747 16.3805C5.65088 16.2765 5.70305 16.1817 5.77848 16.1062L14.2812 7.60347L16.3948 9.71703L7.85766 18.2531Z",
    fill: "#002C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.edd77cb775d08f047a0ff1a66f5fefae.svg";
export { ForwardRef as ReactComponent };